"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const lite_1 = require("algoliasearch/lite");
const react_instantsearch_1 = require("react-instantsearch");
const react_1 = require("@apollo/client/react");
const apolloClient_1 = require("../apolloClient");
const index_1 = require("./index");
const typings_1 = require("../typings");
const constants_1 = require("../constants");
const ContentContainer = ({ configState, configData }) => {
    const selectedTab = configState.selectedTab;
    const [isInitializing, setIsInitializing] = React.useState(true);
    const hasSearchCredentials = Boolean(selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.applicationsKey) &&
        Boolean(selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.apiKey) &&
        Boolean(selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.indexName);
    const searchClient = React.useMemo(() => {
        if (!hasSearchCredentials) {
            return null;
        }
        return (0, lite_1.liteClient)(selectedTab.applicationsKey, selectedTab.apiKey);
    }, [selectedTab.applicationsKey, selectedTab.apiKey, hasSearchCredentials]);
    const apolloClient = React.useMemo(() => {
        return (0, apolloClient_1.createApolloClient)(configData.portfolioApiUrl, configData.languageCode);
    }, [configData.portfolioApiUrl, configData.languageCode]);
    React.useEffect(() => {
        setIsInitializing(true);
        const frameId = globalThis.requestAnimationFrame(() => {
            setIsInitializing(false);
        });
        return () => {
            globalThis.cancelAnimationFrame(frameId);
        };
    }, [apolloClient, searchClient, selectedTab.key]);
    if (!hasSearchCredentials || !searchClient) {
        return null;
    }
    const searchClientConfiguration = React.useMemo(() => selectedTab.key === typings_1.SearchResultTabKeyEnum.Products
        ? `${constants_1.DEFAULT_FILTER_CONFIGURATION} ${constants_1.PRODUCT_FILTER_EXTRA_CONFIGURATION}`
        : constants_1.DEFAULT_FILTER_CONFIGURATION, [selectedTab.key]);
    if (isInitializing)
        return (0, jsx_runtime_1.jsx)(index_1.ContentLoading, {});
    return ((0, jsx_runtime_1.jsx)(react_1.ApolloProvider, { client: apolloClient, children: (0, jsx_runtime_1.jsxs)(react_instantsearch_1.InstantSearch, { searchClient: searchClient, indexName: selectedTab.indexName, stalledSearchDelay: 300, initialUiState: configState.initialUiState, future: { preserveSharedStateOnUnmount: true, persistHierarchicalRootCount: true }, children: [(0, jsx_runtime_1.jsx)(react_instantsearch_1.Configure, { filters: searchClientConfiguration, analyticsTags: configData.algoliaAnalyticsTags }), (0, jsx_runtime_1.jsx)(index_1.Content, { configState: configState })] }, `${selectedTab.key}-${selectedTab.indexName}`) }));
};
exports.ContentContainer = ContentContainer;
